<template>
  <div class="container mt-0 mb-4">
    <div class="card shadow-sm p-4 bg-light">
      <!-- Encabezado -->
      <div class="d-flex align-items-center mb-4">
        <button class="btn btn-outline-secondary me-3" @click="volver">
          ← Regresar
        </button>
        <h3 class="m-0 flex-grow-1 text-center">Registrar Check-In</h3>
      </div>

      <!-- Datos del huésped -->
      <div v-if="reserva" class="mb-4">
        <h5 class="mb-3">Datos del Huésped</h5>
        <p><strong>Nombre:</strong> {{ reserva.huesped?.Nombre }} {{ reserva.huesped?.Apellido }}</p>
        <p><strong>DPI:</strong> {{ reserva.huesped?.DPI }}</p>
        <p><strong>Teléfono:</strong> {{ formatearTelefono(reserva.huesped?.Telefono) }}</p>
        <p><strong>NIT:</strong> {{ reserva.huesped?.NIT }}</p>
        <p><strong>Empresa:</strong> {{ reserva.huesped?.Empresa}}</p>
        <p><strong>Placas:</strong> {{ reserva.huesped?.Placas}}</p>
        <p><strong>Correo:</strong> {{ reserva.huesped?.Correo}}</p>
        <p><strong>Tipo de Huésped:</strong>
  <span v-if="reserva?.huesped?.tipo">
    {{ reserva.huesped.tipo.Tipo }} - {{ reserva.huesped.tipo.Nombre }}
  </span>
  <span v-else>---</span>
</p>


      </div>

     <div class="d-flex justify-content-end">
  <button class="btn btn-sm btn-outline-primary" @click="abrirModalEditarHuesped">
    Editar Huesped
  </button>
</div>


      <!-- Habitaciones reservadas -->
      <div v-if="reserva">
        <h5 class="mb-3">Habitaciones Reservadas</h5>
        <div
          v-for="hab in reserva.habitaciones_reservadas"
          :key="hab.IdReservaHabitacion"
          class="card mb-3 shadow-sm"
        >
          <div class="card-body">
            <p><strong>Habitación:</strong> {{ hab.habitacion?.Numero }} ({{ hab.habitacion?.tipo?.Nombre }})</p>

            <p>
              <strong>Personas alojadas:</strong> {{ hab.CantidadPersonasAlojadas }}
              <button class="btn btn-sm btn-outline-primary ms-2"
                @click="abrirModalEditarCantidad(hab)"
                >
                Editar
              </button>
            </p>

            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="checkinSeleccionado[hab.IdReservaHabitacion]"
                :id="'checkin_' + hab.IdReservaHabitacion"
                :disabled="hab.CheckIn !== null"
              />
              <label class="form-check-label" :for="'checkin_' + hab.IdReservaHabitacion">
                Realizar Check-In
              </label>
            </div>

            <p class="text-muted mt-1" v-if="hab.CheckIn">
              Check-In ya registrado: {{ hab.CheckIn }}
            </p>

            <button
              class="btn mt-3 w-100"
              :class="hab.CheckIn ? 'btn-danger' : 'btn-success'"
              :disabled="hab.CheckIn !== null"
              @click="realizarCheckInHabitacion(hab.IdReservaHabitacion)"
            >
              {{ hab.CheckIn ? 'Check-In Realizado' : 'Confirmar Check-In' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
      <div v-if="mostrarToast" class="toast show text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Modal Check-in Exitoso -->
    <div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="modalVisible" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white shadow">
          <div class="modal-header">
            <h5 class="modal-title">Check-In Exitoso</h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <p class="mensaje-checkin">{{ mensajeCheckIn }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="cerrarModal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Editar Cantidad -->
    <div class="modal fade show d-block" tabindex="-1" role="dialog"
      v-if="modalEditarVisible" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white shadow">
          <div class="modal-header">
            <h5 class="modal-title">Editar Cantidad de Personas</h5>
            <button type="button" class="btn-close" @click="cerrarModalEditar"></button>
          </div>
          <div class="modal-body">
            <label class="form-label">Nueva cantidad de personas</label>
            <input type="number" min="1" class="form-control" v-model.number="cantidadNueva">
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModalEditar">Cancelar</button>
            <button class="btn btn-primary" @click="guardarCantidadActualizada">Guardar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal de Productos a Entregar -->
<div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="modalEntregaVisible" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white shadow">
      <div class="modal-header">
        <h5 class="modal-title">Productos a Entregar</h5>
        <button type="button" class="btn-close" @click="modalEntregaVisible = false"></button>
      </div>
      <div class="modal-body">
        <p>{{ mensajeEntrega }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="modalEntregaVisible = false">Aceptar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Editar Huésped -->
<div class="modal fade show d-block" tabindex="-1" role="dialog"
  v-if="modalHuespedVisible" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-lg modal-dialog-centered"> <!-- Hacerlo grande -->
    <div class="modal-content bg-white shadow">

      <div class="modal-header">
        <h5 class="modal-title">Editar Datos del Huésped</h5>
        <button type="button" class="btn-close" @click="modalHuespedVisible = false"></button>
      </div>

      <div class="modal-body">

        <div class="row">
          <div class="col-md-6 mb-3">
            <label>Nombre</label>
            <input type="text" class="form-control" v-model="huespedEditable.Nombre" />
          </div>

          <div class="col-md-6 mb-3">
            <label>Apellido</label>
            <input type="text" class="form-control" v-model="huespedEditable.Apellido" />
          </div>

          <div class="col-md-6 mb-3">
            <label>DPI</label>
            <input type="text" class="form-control" v-model="huespedEditable.DPI" />
          </div>

          <div class="col-md-6 mb-3">
            <label>Teléfono</label>
<input
  type="text"
  class="form-control"
  :class="{ 'is-invalid': huespedEditable.Telefono.length > 0 && huespedEditable.Telefono.length < 8 }"
  v-model="huespedEditable.Telefono"
  @input="limpiarTelefono"
  maxlength="8"
/>

<div class="invalid-feedback">
  El teléfono debe tener exactamente 8 dígitos.
</div>


          </div>

          <div class="col-md-6 mb-3">
            <label>NIT</label>
            <input type="text" class="form-control" v-model="huespedEditable.NIT" />
          </div>

          <div class="col-md-6 mb-3">
            <label>Empresa</label>
            <input type="text" class="form-control" v-model="huespedEditable.Empresa" />
          </div>

          <div class="col-md-6 mb-3">
            <label>Placas</label>
            <input type="text" class="form-control" v-model="huespedEditable.Placas" />
          </div>

          <div class="col-md-6 mb-3">
            <label>Correo <span class="text-muted">(Opcional)</span></label>
            <input type="email" class="form-control" v-model="huespedEditable.Correo" placeholder="correo@ejemplo.com" />
            <small
              v-if="huespedEditable.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(huespedEditable.Correo)"
              class="text-danger">
              <i class="bi bi-exclamation-triangle-fill"></i> Correo inválido — se omitirá en la factura FEL
            </small>
          </div>


          <div class="col-md-6 mb-3">
            <label>Tipo de Huésped</label>
            <select class="form-select" v-model="huespedEditable.IdTipoHuesped">
              <option
  v-for="t in tiposHuesped"
  :value="t.IdTipoHuesped"
  :key="t.IdTipoHuesped"
>
  {{ t.Tipo }} - {{ t.Nombre }}
</option>

            </select>
          </div>

        </div>

      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" @click="modalHuespedVisible = false">Cancelar</button>
        <button
  class="btn btn-primary"
  @click="guardarHuesped"
  :disabled="huespedEditable.Telefono.length !== 8"
>
  Guardar
</button>

      </div>

    </div>
  </div>
</div>


  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'
import { useRoute } from 'vue-router'

export default {
  name: 'checkInHabitaciones',
  data() {
    return {
      reserva: null,
      checkinSeleccionado: {},
      alerta: { mensaje: '', tipo: 'success' },
      mostrarToast: false,
      modalVisible: false,
      mensajeCheckIn: '',
      modalEditarVisible: false,
      habitacionEditando: null,
      cantidadNueva: 1,
      modalEntregaVisible: false,
      mensajeEntrega: '',
      modalHuespedVisible: false,
huespedEditable: {},
tiposHuesped: [],

    }
  },
  async mounted() {
  const route = useRoute();
  const id = route.params.id;

  // 1. Obtener la reserva
  const res = await axios.get(`${API_URL}/reservas/${id}`);
  this.reserva = res.data.reserva;

  // 2. Obtener los tipos solo una vez
  const tipos = await axios.get(`${API_URL}/tipos-huesped`);
  this.tiposHuesped = tipos.data;

  // 3. Preparar switches del check-in
  this.reserva.habitaciones_reservadas.forEach(hab => {
    this.checkinSeleccionado[hab.IdReservaHabitacion] = false;
  });
},
  methods: {
   abrirModalEditarHuesped() {
  this.huespedEditable = { ...this.reserva.huesped };

  // LIMPIAR TELÉFONO AL ABRIR EL MODAL
  if (this.huespedEditable.Telefono) {
    let limpio = this.huespedEditable.Telefono.replace(/\D/g, '').replace(/^502/, '');
    this.huespedEditable.Telefono = limpio.substring(0, 8);
  }

  this.modalHuespedVisible = true;
},

formatearTelefono(tel) {
    if (!tel) return "";
    return tel.replace(/^502/, ""); // Quitar 502 si aparece
  },

  limpiarTelefono() {
    // Quitar todo lo que no sea número
    let limpio = this.huespedEditable.Telefono.replace(/\D/g, '');

    // Quitar 502 si el backend ya lo devolvió así sin querer
    limpio = limpio.replace(/^502/, "");

    // Limitar a 8 dígitos
    limpio = limpio.substring(0, 8);

    this.huespedEditable.Telefono = limpio;
  },
async guardarHuesped() {
  try {
    await axios.put(`${API_URL}/huesped/${this.huespedEditable.IdHuesped}`, this.huespedEditable);
    this.mostrarToastMensaje('Huésped actualizado correctamente');
    this.modalHuespedVisible = false;

    const nueva = await axios.get(`${API_URL}/reservas/${this.reserva.IdReserva}`);
    this.reserva = nueva.data.reserva;

  } catch (error) {
    this.mostrarToastMensaje('Error al actualizar huésped', 'danger');
  }
}
,
   async realizarCheckInHabitacion(id) {
  if (!this.checkinSeleccionado[id]) {
    this.mostrarToastMensaje('Debe activar el switch para hacer check-in.', 'warning')
    return
  }

  const habitacion = this.reserva.habitaciones_reservadas.find(h => h.IdReservaHabitacion === id)
  const fechaLlegada = habitacion?.FechaLlegada

  const fechaHoy = new Date().toISOString().split('T')[0]
  if (fechaHoy < fechaLlegada) {
    this.mostrarToastMensaje(`El check-in solo se permite a partir del día de llegada: ${fechaLlegada}`, 'warning')
    return
  }

  try {
    const res = await axios.put(`${API_URL}/reservas-habitacion/checkin/${id}`)
    const nueva = await axios.get(`${API_URL}/reservas/${this.reserva.IdReserva}`)
    this.reserva = nueva.data.reserva

    this.mensajeCheckIn = res.data.message
    this.modalVisible = true
  } catch {
    this.mostrarToastMensaje('Error al realizar el check-in.', 'danger')
  }
}

,
    abrirModalEditarCantidad(hab) {
      this.habitacionEditando = hab
      this.cantidadNueva = hab.CantidadPersonasAlojadas
      this.modalEditarVisible = true
    },

    cerrarModalEditar() {
      this.modalEditarVisible = false
    },

 async guardarCantidadActualizada() {
  try {
    const res = await axios.put(`${API_URL}/reservacion-habitacion/${this.habitacionEditando.IdReservaHabitacion}/actualizar-cantidad-personas`, {
      CantidadPersonasAlojadas: this.cantidadNueva
    })
    const nueva = await axios.get(`${API_URL}/reservas/${this.reserva.IdReserva}`)
    this.reserva = nueva.data.reserva

    this.mensajeEntrega = res.data.message
    this.modalEntregaVisible = true
    this.cerrarModalEditar()
  } catch {
    this.mostrarToastMensaje('Error al actualizar cantidad.', 'danger')
  }
}
,

    mostrarToastMensaje(mensaje, tipo = 'success') {
      this.alerta.mensaje = mensaje
      this.alerta.tipo = tipo
      this.mostrarToast = true
      setTimeout(() => {
        this.mostrarToast = false
      }, 3000)
    },
    cerrarToast() {
      this.mostrarToast = false
    },
    cerrarModal() {
      this.modalVisible = false
    },
    volver() {
      this.$router.push('/reservas')
    }
  },
  computed: {
    toastColor() {
      return {
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning text-dark',
        info: 'bg-info text-dark'
      }[this.alerta.tipo] || 'bg-primary'
    },
    iconoToast() {
      return {
        success: 'bi bi-check-circle-fill',
        danger: 'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info: 'bi bi-info-circle-fill'
      }[this.alerta.tipo] || 'bi bi-info-circle-fill'
    }
  }
}
</script>

<style scoped>
label {
  font-weight: 500;
}

.mensaje-checkin {
  white-space: pre-line;
  line-height: 1.8;
  margin: 0;
}
</style>
